import Button from '../Button';
import Icon from '../../icons/Icon';
import IconExpressYourself from '../../icons/IconExpressYourself';
import Modal from '../../modal/Modal';
import React from 'react';
import styled from 'styled-components';

const Message = styled.div`
  font-size: 1.6rem;
  font-weight: 600;
  padding: 0 0 30px;
`;

const ModalReport = props => {
  const { onClose, onValidate, open, theme, t } = props;
  return (
    <Modal onClose={onClose} open={open}>
      <Icon
        icon={IconExpressYourself}
        width={'80px'}
        height={'80px'}
        color={'#fff'}
        margin={'0 auto 20px'}
        padding={'15px'}
        borderRadius={'50%'}
        backgroundColor={theme.mainColor}
      />
      <Message>{t('smart_qa_modal_post_sent')}</Message>
      <Button btntype={'primary'} onClick={onValidate}>
        {t('btn_ok')}
      </Button>
    </Modal>
  );
};

export default ModalReport;
